import { Properties } from "@util/types";
import BudgetCategory from "./BudgetCategory";
import Category from "./Category";
import { RootProductId } from "./Product";

export default class ProductVariant {
	constructor(props: Omit<Properties<ProductVariant>, "product">) {
		this.id = props.id;
		this.budgetCategories = props.budgetCategories;
	}

	readonly id: string;
	readonly budgetCategories: BudgetCategory[];

	static fromJson(data: any, productId: RootProductId): ProductVariant {
		return new ProductVariant({
			...data,
			budgetCategories: data.budgetCategories.map((bcData: any) =>
				BudgetCategory.fromJson(bcData, productId)
			),
		});
	}

	findCategory(categoryId: string): BudgetCategory | Category | undefined {
		for (const category of this.budgetCategories) {
			if (category.id === categoryId) {
				return category;
			}

			const found = category.findCategory(categoryId);
			if (found) return found;
		}
		return undefined;
	}
}
